<template>
    <v-container fluid v-if="filterNotifications && route.currentRoute.value.name !== 'notifications'" class="notification pa-0">
        <div v-for="notification in filterNotifications" class="pt-2 pb-2" :key="notification.id">
            <v-alert density="compact" flat :type="getNotificationType(notification.typeId)" :icon="notification.icon" elevation="0" closable class="mx-1 mb-0 py-3">
                <template v-slot:close="{}">
                    <v-btn tag="a" icon size="28" @click="dismiss(notification)" density="compact" :color="'#f0f0f0'" class="notification-close-btn">
                        <v-icon size="24" :color="theme.name.value === 'dark' ? '#b5bac1' : 'white'" class="alert-close" :icon="mdiClose" />
                    </v-btn>
                </template>
                <span class="whiteTextDark" v-html="notification.text"></span>
            </v-alert>
        </div>
    </v-container>
</template>

<style scoped>
    .v-alert :deep(.mdi-information-outline),
    .v-alert :deep(.mdi-alert-outline),
    .v-alert :deep(.mdi-error-outline),
    .v-alert :deep(.mdi-warning-outline) {
        font-size: 24px !important;
    }
    :deep(.v-alert__close) {
        margin-inline-start: 12px !important;
    }
</style>

<script lang="ts" setup>
    import { computed, onMounted, onBeforeUnmount } from 'vue';
    import eventBus from '@/services/eventBus';
    import { useAppStore } from '@/stores/app';
    import { NotificationItem } from '@/models/notification';
    import { EventName, NotificationType } from '@/constants';
    import { notificationService } from '@/services/notificationService';
    import { useTheme } from 'vuetify';

    const appStore = useAppStore();
    const route = useRouter();
    const theme = useTheme();

    const filterNotifications = computed<NotificationItem[]>(() => {
        if (appStore.notifications.length === 0) return [];
        return appStore.notifications
            .filter((notification) => notification.typeId !== NotificationType.Notification && notification.typeId !== NotificationType.Message)
            .slice(0, 2) as NotificationItem[];
    });

    const dismiss = (notification: NotificationItem) => {
        notificationService.update(notification.id).then(() => {
            appStore.notifications = appStore.notifications.filter((n) => n.id !== notification.id);
        });
        eventBus.emit(EventName.PageReload);
    };

    const getNotificationType = (typeId: number): 'error' | 'success' | 'warning' | 'info' => {
        switch (typeId) {
            case NotificationType.Info:
                return 'info';
            case NotificationType.Warning:
                return 'warning';
            case NotificationType.Error:
                return 'error';
            case NotificationType.Notification:
                return 'info';
            default:
                return 'info';
        }
    };

    onMounted(() => {
        console.log('Component app-notification mounted.');
    });

    onBeforeUnmount(() => {
        console.log('Component app-notification destroyed.');
    });
</script>
<style scoped>
    .whiteTextDark {
        color: #f0f0f0;
    }
</style>
